import { useEffect, useRef } from 'react';
import { AccommodationCombined } from '../Accommodations/Accommodation.types';
import { useAccommodationsHotelsCounts } from './useAccommodationsHotelsCounts';
import { useCustomPageTelemetry } from '@apps/guest/packages/layout-engine/widgets/Custom/Custom.telemetry';

interface AccommodationsHotelsCountProps {
  accommodations: AccommodationCombined[];
}

export const AccommodationsHotelsCount = ({ accommodations }: AccommodationsHotelsCountProps) => {
  const isTelemetryCalledRef = useRef<boolean>(false);

  const telemetry = useCustomPageTelemetry();

  const { accommodationsHotelsCounts, accommodationsHotelsCountsLoading } = useAccommodationsHotelsCounts(accommodations);

  useEffect(() => {
    if (accommodationsHotelsCountsLoading || isTelemetryCalledRef.current) return;
    telemetry.guestAccommodationsData('accommodations', accommodationsHotelsCounts);
    isTelemetryCalledRef.current = true;
  }, [accommodationsHotelsCounts, accommodationsHotelsCountsLoading, telemetry]);

  return null;
};
